import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

interface ReportCounts {
  byVehicle: Array<{ id: string; count: number }>;
  byCompartment: Array<{ id: string; count: number }>;
  byItem: Array<{ id: string; count: number }>;
  byWarehouse: Array<{ id: string; count: number }>;
}

/** Carica counts segnalazioni per tutti i target (vehicle/compartment/item/warehouse). */
export function useReportCounts(): {
  vehicle: Map<string, number>;
  compartment: Map<string, number>;
  item: Map<string, number>;
  warehouse: Map<string, number>;
} {
  const { data } = useQuery<ReportCounts>({
    queryKey: ['reports.counts'],
    queryFn: async () => (await api.get('/reports/counts')).data,
  });
  const toMap = (arr: Array<{ id: string; count: number }> | undefined) =>
    new Map((arr ?? []).map(x => [x.id, x.count]));
  return {
    vehicle: toMap(data?.byVehicle),
    compartment: toMap(data?.byCompartment),
    item: toMap(data?.byItem),
    warehouse: toMap(data?.byWarehouse),
  };
}
